import axios from "axios";
import logService from "@/services/log.service.js";

const VogtConfigurationService = {
    /**
     * check if we have a valid configuration
     * @returns {boolean}
     */
    hasConfiguration() {
        return Boolean(this.getConfiguration());
    },

    /**
     * get the current configuration
     * @returns {string}
     */
    getConfiguration() {
        return JSON.parse(localStorage.getItem('vogt.app_config'));
    },

    /**
     * set the configursation
     * @param configuration
     */
    setConfiguration(configuration) {
        localStorage.setItem('vogt.app_config', JSON.stringify(configuration));
    },

    /**
     * get a specific configuration property
     **/
    get(key) {
        const config = this.getConfiguration();
        if (!config) return null;

        const keys = key.split('.');
        let result = config;

        for (const k of keys) {
            if (result[k] === undefined) return null;
            result = result[k];
        }

        return result;
    },

    /**
     * load the remote json configuration
     */
    async loadRemoteConfiguration(storeInLocalStorage = false) {
        let config = await axios.get('https://silokonfigurator.vogt-lagersysteme.de/output/config.json');
        if (config.status !== 200) {
            throw new Error('Leider trat ein Fehler auf die config.json zu laden');
        }

        let configuration = JSON.stringify(config.data);
        if (!configuration) {
            throw new Error('Leider trat ein Fehler auf die config.json zu laden');
        }

        if (storeInLocalStorage) {
            this.setConfiguration(config.data);
        }

        logService.add('Added remote configuration (config.json)');
        return config.data;
    }

}

export default VogtConfigurationService;